var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5469 10.305C27.3962 9.75563 26.8969 9.375 26.3275 9.375C23.68 9.375 16.32 9.375 13.6725 9.375C13.1031 9.375 12.6037 9.75563 12.4531 10.305C11.7419 12.8944 9.79187 20 9.79187 20H30.2081C30.2081 20 28.2581 12.8944 27.5469 10.305Z",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0669 23.75C33.0181 23.4625 32.9387 23.1806 32.83 22.9087C32.585 22.2956 32.2362 21.4237 31.9844 20.795C31.7925 20.315 31.3275 20 30.8106 20C27.1513 20 12.8488 20 9.18938 20C8.6725 20 8.2075 20.315 8.01562 20.795C7.76375 21.4237 7.415 22.2956 7.17 22.9087C6.975 23.3956 6.875 23.915 6.875 24.4394V27.485C6.875 28.1838 7.44125 28.75 8.14 28.75C10.745 28.75 16.9337 28.75 22.5 28.75",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23938 23.4894H9.94125C10.52 23.4894 11.0488 23.8163 11.3075 24.3338C11.6156 24.95 11.9794 25.6769 11.9794 25.6769",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.1144C10 19.1144 8.94312 16.9269 7.60437 16.9269",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2081 19.1144C30.2081 19.1144 31.265 16.9269 32.6044 16.9269",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4375 29.0625H9.0625V31.3625C9.0625 31.6638 9.1825 31.9531 9.39562 32.1669C9.60938 32.38 9.89875 32.5 10.2 32.5C10.8469 32.5 11.6531 32.5 12.3 32.5C12.6013 32.5 12.8906 32.38 13.1044 32.1669C13.3175 31.9531 13.4375 31.6638 13.4375 31.3625C13.4375 30.3613 13.4375 29.0625 13.4375 29.0625Z",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 25.625C35 24.5894 34.1606 23.75 33.125 23.75C31.3381 23.75 28.6619 23.75 26.875 23.75C25.8394 23.75 25 24.5894 25 25.625C25 26.8875 25 28.58 25 30.0319C25 31.8775 26.0825 33.5512 27.7656 34.3075C28.9212 34.8275 30 35.3125 30 35.3125C30 35.3125 31.0788 34.8275 32.2344 34.3075C33.9175 33.5512 35 31.8775 35 30.0319V25.625Z",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9688 29.2175L29.5312 30.4675L32.0312 28.28",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService5);
export default __webpack_public_path__ + "static/media/service5.9b1e740087f529837e857a0d6517bcd3.svg";
export { ForwardRef as ReactComponent };